import { OpeningHoursState } from "./state";

export const selectOpeningHoursState = (state: { openingHours: OpeningHoursState }): OpeningHoursState =>
	state.openingHours;
